import MenuHeader from '@/components/MenuHeader';
import AlertNotification from '@/components/AlertNotification';
import { mapState } from 'vuex';

function checkPageNotification(pageName) {
  if (pageName === 'Statements' ||
    pageName === 'Company' ||
    pageName === 'PowerOfAttorney' ||
    pageName === 'Users' ||
    pageName === 'Content' ||
    pageName === 'Domains') {
    return true;
  }

  return false;
};

export default {
  name: 'DefaultContainer',
  data() {
    return {
      isShoWAlertNotification: false
    };
  },
  components: {
    MenuHeader,
    AlertNotification
  },
  created() {
    this.isShoWAlertNotification = checkPageNotification(this.$route.name);
  },
  computed: {
    ...mapState({
      toggleAlertNotificationNoPowersOfAttorney: state => state.toggleAlertNotificationNoPowersOfAttorney,
      toggleAlertNotificationExpiringPowersOfAttorney: state => state.toggleAlertNotificationExpiringPowersOfAttorney
    })
  },
  beforeUpdate() {
    this.isShoWAlertNotification = checkPageNotification(this.$route.name);
  }
};
